/**
 * Zopup - Product Catalogue API
 * Zopup - Product Catalogue API
 *
 * OpenAPI spec version: v1
 * Contact: djoyrocks@gmail.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */

// Third party library imports
import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

// Zopup library imports
import { 
    TenantUomPreferenceDto,
    TenantUomPreferenceDtoListWebApiResponse,
    TenantUomPreferenceDtoWebApiResponse,
    TenantUomPreferenceUpsertCommand,
    BooleanWebApiResponse,
} from '@zopup/zop-types';

// Internal project imports
import { BaseService } from '../api.base.service';
import { Configuration } from '../configuration';
import { CustomHttpUrlEncodingCodec } from '../encoder';
import { PRODUCT_CATALOGUE_API_BASE_PATH } from '../api-tokens';

@Injectable({
    providedIn: 'root'
})
export class TenantUomPreferenceService extends BaseService {

    constructor(
        protected httpClient: HttpClient,
        @Inject(PRODUCT_CATALOGUE_API_BASE_PATH) private apiBasePath: string
    ) {
        super();
        this.basePath = this.apiBasePath;
        this.configuration.basePath = this.basePath;
    }

    /**
     * Delete tenant UOM preferences
     * 
     * @param xTenantId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public tenantUomPreferencesDelete(xTenantId: string, observe?: 'body', reportProgress?: boolean): Observable<BooleanWebApiResponse>;
    public tenantUomPreferencesDelete(xTenantId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BooleanWebApiResponse>>;
    public tenantUomPreferencesDelete(xTenantId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BooleanWebApiResponse>>;
    public tenantUomPreferencesDelete(xTenantId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (xTenantId === null || xTenantId === undefined) {
            throw new Error('Required parameter xTenantId was null or undefined when calling tenantUomPreferencesDelete.');
        }

        let headers = this.defaultHeaders;
        if (xTenantId !== undefined && xTenantId !== null) {
            headers = headers.set('x-tenant-id', String(xTenantId));
        }

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<BooleanWebApiResponse>('delete',`${this.basePath}/TenantUomPreferences`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get tenant UOM preferences
     * 
     * @param xTenantId 
     * @param orderBy 
     * @param isOrderByDescending 
     * @param searchText 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public tenantUomPreferencesGet(xTenantId: string, orderBy?: Array<string>, isOrderByDescending?: boolean, searchText?: string, observe?: 'body', reportProgress?: boolean): Observable<TenantUomPreferenceDtoListWebApiResponse>;
    public tenantUomPreferencesGet(xTenantId: string, orderBy?: Array<string>, isOrderByDescending?: boolean, searchText?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TenantUomPreferenceDtoListWebApiResponse>>;
    public tenantUomPreferencesGet(xTenantId: string, orderBy?: Array<string>, isOrderByDescending?: boolean, searchText?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TenantUomPreferenceDtoListWebApiResponse>>;
    public tenantUomPreferencesGet(xTenantId: string, orderBy?: Array<string>, isOrderByDescending?: boolean, searchText?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (xTenantId === null || xTenantId === undefined) {
            throw new Error('Required parameter xTenantId was null or undefined when calling tenantUomPreferencesGet.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (orderBy) {
            orderBy.forEach((element) => {
                queryParameters = queryParameters.append('OrderBy', <any>element);
            })
        }
        if (isOrderByDescending !== undefined && isOrderByDescending !== null) {
            queryParameters = queryParameters.set('IsOrderByDescending', <any>isOrderByDescending);
        }
        if (searchText !== undefined && searchText !== null) {
            queryParameters = queryParameters.set('SearchText', <any>searchText);
        }

        let headers = this.defaultHeaders;
        if (xTenantId !== undefined && xTenantId !== null) {
            headers = headers.set('x-tenant-id', String(xTenantId));
        }

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<TenantUomPreferenceDtoListWebApiResponse>('get',`${this.basePath}/TenantUomPreferences`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Upsert tenant UOM preferences
     * 
     * @param xTenantId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public tenantUomPreferencesPut(xTenantId: string, body?: TenantUomPreferenceUpsertCommand, observe?: 'body', reportProgress?: boolean): Observable<TenantUomPreferenceDtoWebApiResponse>;
    public tenantUomPreferencesPut(xTenantId: string, body?: TenantUomPreferenceUpsertCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TenantUomPreferenceDtoWebApiResponse>>;
    public tenantUomPreferencesPut(xTenantId: string, body?: TenantUomPreferenceUpsertCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TenantUomPreferenceDtoWebApiResponse>>;
    public tenantUomPreferencesPut(xTenantId: string, body?: TenantUomPreferenceUpsertCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (xTenantId === null || xTenantId === undefined) {
            throw new Error('Required parameter xTenantId was null or undefined when calling tenantUomPreferencesPut.');
        }

        let headers = this.defaultHeaders;
        if (xTenantId !== undefined && xTenantId !== null) {
            headers = headers.set('x-tenant-id', String(xTenantId));
        }

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<TenantUomPreferenceDtoWebApiResponse>('put',`${this.basePath}/TenantUomPreferences`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get single tenant UOM preference
     * 
     * @param xTenantId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public tenantUomPreferencesSingleGet(xTenantId: string, observe?: 'body', reportProgress?: boolean): Observable<TenantUomPreferenceDtoWebApiResponse>;
    public tenantUomPreferencesSingleGet(xTenantId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TenantUomPreferenceDtoWebApiResponse>>;
    public tenantUomPreferencesSingleGet(xTenantId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TenantUomPreferenceDtoWebApiResponse>>;
    public tenantUomPreferencesSingleGet(xTenantId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (xTenantId === null || xTenantId === undefined) {
            throw new Error('Required parameter xTenantId was null or undefined when calling tenantUomPreferencesSingleGet.');
        }

        let headers = this.defaultHeaders;
        if (xTenantId !== undefined && xTenantId !== null) {
            headers = headers.set('x-tenant-id', String(xTenantId));
        }

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<TenantUomPreferenceDtoWebApiResponse>('get',`${this.basePath}/TenantUomPreferences/single`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }
}
